import { render } from "./RecommendedProviders.vue?vue&type=template&id=317d02a8&scoped=true"
import script from "./RecommendedProviders.vue?vue&type=script&lang=js"
export * from "./RecommendedProviders.vue?vue&type=script&lang=js"

import "./RecommendedProviders.vue?vue&type=style&index=0&id=317d02a8&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317d02a8"]])

export default __exports__